"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAllCustomTableViewsWatcher = loadAllCustomTableViewsWatcher;

var _effects = require("redux-saga/effects");

var actions = _interopRequireWildcard(require("./actions"));

var customTableViewsActions = _interopRequireWildcard(require("../../../customTableViews/actions"));

var types = _interopRequireWildcard(require("./types"));

var _apiRequest = require("../../api/apiRequest");

var _selectors = require("../../../user/selectors");

var _data = require("../../../../constants/data");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(loadAllCustomTableViewsWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadAllCustomTableViewsWatcher);

function loadAllCustomTableViewsWorker() {
  var userName, data;
  return regeneratorRuntime.wrap(function loadAllCustomTableViewsWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)(actions.start());

        case 3:
          _context.next = 5;
          return (0, _effects.select)(_selectors.getUserName);

        case 5:
          userName = _context.sent;
          _context.next = 8;
          return (0, _effects.call)(_apiRequest.apiRequest, _data.DATA_URLS.CUSTOM_TABLE_VIEW_LOAD_URL, "GET", {
            query: {
              user: userName
            }
          });

        case 8:
          data = _context.sent;
          _context.next = 11;
          return (0, _effects.put)(customTableViewsActions.set(data.views));

        case 11:
          _context.next = 13;
          return (0, _effects.put)(actions.success());

        case 13:
          _context.next = 20;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          _context.next = 20;
          return (0, _effects.put)(actions.failure());

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 15]]);
}

function loadAllCustomTableViewsWatcher() {
  return regeneratorRuntime.wrap(function loadAllCustomTableViewsWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, loadAllCustomTableViewsWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}